import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async verificarPesoMaximoFreteOrcamento(axios, parametros) {        
    parametros.operacao = 'verificarPesoMaximoFreteOrcamento'

    let retorno = {}

    await axios.santriGET('/rest/orcamento', parametros, 20, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data.mensagem_validacao_peso_frete)
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoVerificarPesoMaximoFreteOrcamento.js